import {ButtonGroup, Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import { useState } from "react";
import { CommonDropDownType } from "../../types/buttons/ButtonsTypes";
import { useTranslation } from "react-i18next";

const CommonDropDown: React.FC<CommonDropDownType> = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(!dropdownOpen);
  const { t } = useTranslation();
  return (
    <ButtonGroup>
      <Dropdown isOpen={dropdownOpen} toggle={toggle}>
        <DropdownToggle
          caret
          color="btn-info "
          className="text-white btn btn-info no-radius"
        >
          <i className="fa fa-upload p-1" />
          {t("Export")}
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem>
            <i className="fa fa-file-pdf-o p-1 me-2 text-info"></i>
            {t("pdf")}
          </DropdownItem>
          <DropdownItem>
            <i className="fa fa-file-excel-o me-2 p-1 text-success" aria-hidden="true"></i>
            {t("Excel")}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </ButtonGroup>
  );
};

export default CommonDropDown;
